import React from 'react';
import * as actions from '../../../../../store/actions/indexes';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux'
import HorizontalTable from './Horizontal.Table';
import VerticalTable from './Vertical.Table';
import "../common.css";
import SignatureDetailsModal from "../../SignatureDetailsModal/index";

class TableContainer extends React.Component {
    constructor(props) {
        super(props);
        this.props = props;

        // this.handleClick = this.handleClick.bind(this);
    }

    // componentDidMount() {
    //     window.addEventListener('click', this.handleClick);
    // }
    
    // handleClick(e){
    //     if(this.props.clickedOn != 0 && this.props.popupStatus && (Date.now() - this.props.clickedOn > 1000)){
    //         this.props.resetPopupMatrix();
    //     }
    //     // this.timestamp = Date.now();
    // }

    // timestamp = 0;
    currentScroll = 0;
    currentScrollLeft = 0;

    render() {
        // alert(this.props.popupStatus)
        return (
            <div 
            // onScroll={() => {
            //     let scrollTop = 0;
            //     let scrollLeft = 0;
            //     if(this.props.transpose != 'horizontal'){
            //         scrollTop = document.getElementsByClassName("ant-table-body")[0].scrollTop;
            //         scrollLeft = document.getElementsByClassName("ant-table-body")[0].scrollLeft;
            //     }else{
            //         scrollTop = document.getElementsByClassName("ant-table-body")[1].scrollTop;
            //         scrollLeft = document.getElementsByClassName("ant-table-body")[1].scrollLeft;
            //     }

            //     // console.log("SCRIOLLTOP", scrollTop, this.props.popupStatus)
            //     if(this.props.popupStatus && (this.currentScroll != scrollTop || this.scrollLeft != scrollLeft)){
            //         this.currentScroll = scrollTop;
            //         this.scrollLeft = scrollLeft;
            //         // this.props.setPopupOpen(false);
            //         this.props.resetPopupMatrix();
            //     }
            // }}
                
            >
                {/* <button onClick={() => { this.props.setPopupOpen(true) }}>Set {this.props.popupStatus+""}</button> */}
                <SignatureDetailsModal/>
                <div style={{ display: (this.props.transpose != 'horizontal') ? 'block' : 'none' }}>
                    <HorizontalTable 
                        settings={this.props.settings}
                        // transpose={this.props.transpose}
                        // status={this.props.status}
                        changeHotelView={this.props.changeHotelView}
                        // selectedHotels={this.props.selectedHotels}
                        // complianceData={this.props.qmsApi.complianceTableData}
                    />
                </div>
                <div style={{ display: (this.props.transpose == 'horizontal') ? 'block' : 'none' }}>
                    <VerticalTable 
                        settings={this.props.settings}
                        // transpose={this.props.transpose}
                        // status={this.props.status}
                        changeHotelView={this.props.changeHotelView}
                        // selectedHotels={this.props.selectedHotels}
                        // complianceData={this.props.qmsApi.complianceTableData}
                    />
                </div>
                {/* {(this.props.transpose == 'horizontal') ?
                    <HorizontalTable settings={this.props.settings} transpose={this.props.transpose} status={this.props.status} changeHotelView={this.props.changeHotelView} selectedHotels={this.props.selectedHotels} complianceData={this.props.complianceData} />
                    : <VerticalTable settings={this.props.settings} transpose={this.props.transpose} status={this.props.status} changeHotelView={this.props.changeHotelView} selectedHotels={this.props.selectedHotels} complianceData={this.props.complianceData} />
                } */}
            </div>

        )
    }
}

const mapStateToProps = (state) => {
    return {
        // qmsApi: state.qmsApi,
        transpose: state.complianceTableReducer.transpose
        // popupStatus: state.popupStatusReducer.popupStatus,
        // clickedOn: state.popupStatusReducer.clickedOn
    }
  }
  
function mapDispatchToProps(dispatch){
    return bindActionCreators({ 
        // setPopupOpen : actions.setPopupOpen,
        // resetPopupMatrix : actions.resetPopupMatrix
    }, dispatch);
  }

export default connect(mapStateToProps, mapDispatchToProps)(TableContainer);